import { Box } from "@chakra-ui/react"
import type { ReactNode } from "react"

type SectionCardProps = {
  children: ReactNode
  title?: string
}

export default function SectionCard({ children }: SectionCardProps) {
  return (
    <Box bg="gray.800" p="5" borderRadius="lg">
      {children}
    </Box>
  )
}
